import { axiosClient } from './AxiosClient'
import { baseURL } from '../Network/Config'
import dayjs from 'dayjs'
import axios from 'axios'

function getDashboard(companyId, callback, errorCallback){
    let url = "/dashboard/admin"
    var bodyForm = new FormData()
    const buildingId = localStorage.getItem("building_id")
    if(companyId !== null){
        bodyForm.append("companyId", companyId)
        bodyForm.append("building_id", buildingId)
    }

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function taskDashboard(
    repairId,
    callback,
    errorCallback
){
    let url = baseURL + "/dashboard/admin/task" 

    let today = dayjs().format('D/M/YYYY')

    var formData = new FormData()
    //formData.append("start", today)
    if(repairId !== null){
        formData.append("repair_id", repairId)
    }
    
    axiosClient.post(url, formData)
    .then((response)=>{
        callback(response.data)
        console.log(response.data)
    })
    .catch((error)=>{
        console.log(error.response)
        console.log("error")
        errorCallback(error)
    })
}

function todayWidget(longitude, latitude, lang, callback, errorCallback){
    let url = "/today"

    var params = {
        latitude: latitude,
        longitude: longitude,
        lang: lang
    }

    axiosClient.get(url,{
        params: params
    })
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

export { getDashboard, todayWidget, taskDashboard }
